import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PopupToggler } from '../../blocks/PopupToggler/PopupToggler';
import BulkInventoryEditActionButton from '../BulkInventoryEditActionButton/BulkInventoryEditActionButton';
import styles from './BulkInventoryEditActionsDropdown.module.scss';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

export default function BulkInventoryEditActionsDropdown({ actions = [], fontSize = '14px', isDisabled = false }) {
  const enabledActions = actions.filter((action) => action.isFeatureEnabled);

  if (enabledActions.length === 1) {
    const action = enabledActions[0];
    return (
      <BulkInventoryEditActionButton
        isEditEnabled={action.isButtonEnabled}
        onClick={action.onClick}
        buttonText={action.label}
        tooltipText={action.tooltipText}
        isDisabled={isDisabled}
      />
    );
  }

  return (
    <PopupToggler
      trigger={
        <span className={styles.popupToggleButtonTrigger}>
          <FontAwesomeIcon icon={faEdit} />
          Actions
        </span>
      }
      shouldTriggerOnMouseEnter={true}
      disabled={enabledActions.every((action) => !action.isButtonEnabled)}
      fontSize={fontSize}
    >
      <ul className={styles.actionList}>
        {enabledActions.map((action) => (
          <li
            key={action.id}
            className={classNames(
              styles.actionListItem,
              !action.isButtonEnabled && styles.disabledActionListItem,
              action?.uiOptions?.shouldHaveAdditionalPaddingTop && styles.additionalPaddingTop,
            )}
            onClick={action.onClick}
          >
            {action.label}
          </li>
        ))}
      </ul>
    </PopupToggler>
  );
}
